module.exports = __webpack_public_path__ + "img/newspapers_button_left_up.d5054c3f.png";